module.exports = __webpack_public_path__ + "static/img/bg-1.a22b37ab.webp";